import { GetExternalBasketResponse } from '@1po/1po-bff-fe-spec/generated/external_basket/response/GetExternalBasketResponse';
import { APP_NAMESPACE } from 'app/App.constants';

export const EXTERNAL_BASKET_CONTEXT_NAMESPACE = `${APP_NAMESPACE}/EXTERNAL_BASKET_CONTEXT`;
export const ATTACH_EXTERNAL_BASKET = `${EXTERNAL_BASKET_CONTEXT_NAMESPACE}/ATTACH_EXTERNAL_BASKET`;

export interface ExternalBasketState {
  externalBaskets: GetExternalBasketResponse[];
}
